import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-info-strip',
    templateUrl: './info-strip.component.html',
    styleUrls: ['./info-strip.component.scss'],
    standalone: false
})
export class InfoMessageStripComponent {
    @Input() infoText: string;
    @Input() moreDetails: string;
    @Output() moreInfoClick: EventEmitter<any> = new EventEmitter<any>();

    onMoreDetailsClicked() {
        this.moreInfoClick.emit();
    }
}
